import React from 'react'

import JargonCard from '@cinch/oxd-components/jargon-card/src'
import Link, { Appearance } from '@cinch/oxd-components/link/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import * as styles from './jargon.module.css'

const Jargon: React.FC<{
  i18n: Pick<Cinch.WebAppTranslations['manufacturer'], 'jargon' | 'viewJargon'>
  jargon: Array<{ question: string; summary: string; id: string; uid: string }>
}> = ({ i18n, jargon }) => (
  <div data-testid="jargon" className={styles.jargon}>
    <Text oxford={true} className={styles.title} element={'h3'} type={TextStyles.vehicleSubTitle}>
      {i18n.jargon}
    </Text>
    <div className={styles.jargonCards}>
      {jargon.map((item) => (
        <div key={item.id} className={styles.jargonCard} data-testid="jargon-card">
          <JargonCard {...item} />
        </div>
      ))}
    </div>
    <Link oxford={true} data-testid="view-jargon" appearance={Appearance.tertiaryButton} to="/jargon">
      {i18n.viewJargon}
    </Link>
  </div>
)

export default Jargon
